import { getImage } from './imageRegistry';

export const instructors = [
  {
    name: "Jia Li",
    title: "CEO, Sr. Instructor",
    photo: getImage('instructor_jia_li_gallery'),
    size: "large",
    slug: "jia-li",
    blurb: "Your strength is already within you. My job? To help you uncover it—one intentional, joyful, unstoppable step at a time",
    sections: [
      {
        title: "Bio",
        content: "While pursuing my graduate degree in Acupuncture in New York City, I discovered movement as more than fitness—it became a way of living. Gyrotonic and Pilates grew into my pillars, balancing the rigor of my studies with the joy of teaching clients from all walks of life.<br><br>My movement teaching led me from physical therapy clinics to boutique studios and big-box gyms, but I've always been most inspired by those told their bodies couldn't—clients with chronic pain, scoliosis, hypermobility, and mothers reclaiming strength postpartum. Nothing fuels me more than witnessing that moment when someone moves with newfound freedom and thinks: I'm so much stronger than I knew.<br><br>The last two years have been the most transformative yet. I built my first Pilates brand from the ground up, expanding to two bustling Chicago locations. That journey pushed me as a teacher, a leader, and a student of movement—and it clarified my true passion: creating spaces where people don't just work out, but connect—to their bodies, to their potential, and to each other.<br><br>Now, The <span style=\"color: #BFA19B;\">Sol</span> Room is here. It's my love letter to movement and wellness that empowers. To progress that's imperfect but persistent. To show up—for yourself, for a community that roots for you—because that's where the magic happens."
      },
      {
        title: "Qualifications",
        content: `• Romana's Pilates Level 5 Instructor
• Certified Level 1 & 2 GYROTONIC® Instructor
• Certified Level 1 GYROKINESIS® Instructor
• Certified GYROTONIC® Jumping-Stretching Board Instructor
• BASI Certified Comprehensive Pilates Instructor
• PMA Certified Pilates Instructor
• M.Sc., Acupuncture. NCCAOM Board Certified Licensed Acupuncturist
• B.Sc., Physiology Neurobiology and Molecular Cell Biology (Double Major)
• Myopain Seminars Dry Needling I & II`
      }
    ]
  },
];